// eslint-disable-next-line import/prefer-default-export
export const isAlelo = $route => {
  const { programId = '' } = $route?.params || {};
  const programs = ['111223', '10004'];
  return programs.includes(programId);
};
